import { Controller } from "@hotwired/stimulus"

// Fired on the container after the pristine copy is stamped back.
export const RESTORED_EVENT = "modal-form-reset:restored"

// Restores an inline modal form to its pristine state when the modal is dismissed.
//
// Modal-hosted "New …" forms (e.g. New Link Section, New Document Section, New
// Document) submit over Turbo: a validation error replaces the live form node via
// turbo_stream so the admin can fix and resubmit without leaving the page. But
// Bootstrap only HIDES the modal on Cancel/close — it never restores the DOM. So an
// admin who hits a validation error, dismisses, then reopens would see the previous
// attempt's errored form instead of a clean one.
//
// We keep a pristine copy of the form in an inert <template> (its content is never
// live, so it stays untouched by submits) and stamp it back into the live container
// on hidden.bs.modal. Generic — works for any gl_modal that wires up the two targets.
export default class extends Controller {
  static targets = ["pristine", "container"]

  connect() {
    this._boundReset = () => this.reset()
    this.element.addEventListener("hidden.bs.modal", this._boundReset)
  }

  disconnect() {
    this.element.removeEventListener("hidden.bs.modal", this._boundReset)
  }

  reset() {
    if (!this.hasPristineTarget || !this.hasContainerTarget) return

    this.containerTarget.innerHTML = this.pristineTarget.innerHTML
    // A card-dirty on the same modal (BUTTON-9) re-reads the restored form:
    // innerHTML fires no input event, so the Save would keep its last state.
    this.containerTarget.dispatchEvent(new Event("input", { bubbles: true }))
    // The pristine copy IS the loaded state, so a card-dirty on the modal
    // takes it as its baseline again: a refused submit that replaced the whole
    // form can leave that baseline describing nodes that no longer exist, and
    // a reopened blank form must read clean (BUTTON-9).
    this.containerTarget.dispatchEvent(new CustomEvent(RESTORED_EVENT, { bubbles: true }))
  }
}
